import { createAction } from '@reduxjs/toolkit'

export const updateConnector = createAction<{ connector: string }>('wallet/updateConnect')
export const updateAccount = createAction<{ account: string }>('wallet/updateAccount')
